/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { OrderedList, ListItem } from 'carbon-components-react';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@ibm-watson/shared/store';
import { getBranding } from '../../../../ia/util/branding';
import { selectDraftIntegration } from '../../../store/channels/selectors';
import { QuickSetupComponentProps } from '../../../util/types';
import { messages as QuickSetupShared } from '../../common/quick-setup/messages';
import { IntroStepMessages } from './messages';

export const IntroStep = ({ markStepComplete }: QuickSetupComponentProps) => {
  const draftIntegration = useAppSelector(selectDraftIntegration);

  const { productName } = getBranding();

  /**
   * When we load, we need to mark this step complete.
   */
  useEffect(() => {
    markStepComplete(true);
  }, [markStepComplete]);

  return (
    <div className="TabContent__body-content TabContent__body-outdent">
      <div className="QuickSetup__step-title">
        <FormattedMessage {...QuickSetupShared.getStarted} />
      </div>
      <div className="TabContent__spacer8" />
      <div className="TabContent__subtitle">
        {draftIntegration?.description}
      </div>
      <div className="TabContent__subtitle">
        <h4 className="productive-heading-02">
          <FormattedMessage
            {...IntroStepMessages.instructions}
            values={{ productName }}
          />
        </h4>
      </div>
      <OrderedList className="TabContent__subtitle">
        <ListItem>
          <FormattedMessage {...IntroStepMessages.authenticationStep} />
        </ListItem>
        <ListItem>
          <FormattedMessage {...IntroStepMessages.mappingStep} />
        </ListItem>
      </OrderedList>
    </div>
  );
};
